import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';

export const setShifts = createAction('SET_SHIFTS');
export const setShiftDisplayState = createAction('SET_SHIFT_DISPLAY_STATE');
export const resetShiftList = createAction('RESET_SHIFT_LIST');
export const setShiftPageNumber = createAction('SET_SHIFT_PAGE_NUMBER');
export const setShiftSort = createAction('SET_SORT');
export const setShiftSortOrder = createAction('SET_SORT_ORDER');
export const setStatusFilter = createAction('SET_SHIFT_STATUS_FILTER');
export const setOrgFilter = createAction('SET_ORG_FILTER');
export const setOrgStatusFilter = createAction('SET_SHIFT_ORG_STATUS_FILTER');
export const setShiftTimeZoneFilter = createAction('SET_SHIFT_TIMEZONE_FILTER');
export const setLocFilter = createAction('SET_LOC_FILTER');
export const setDeptFilter = createAction('SET_DEPT_FILTER');
export const setRoleFilter = createAction('SET_ROLE_FILTER');
export const setFromDateFilter = createAction('SET_FORM_DATE_FILTER');
export const setToDateFilter = createAction('SET_TO_DATE_FILTER');
export const setSupervisorIdFilter = createAction('SET_SUPREVISOR_ID_FILTER');
export const setCancelReason = createAction('SET_TO_CANCEL_REASON_FILTER');
export const setSupervisorList = createAction('SET_SUPERVISOR_LIST');
export const setStateFilter = createAction('SET_STATE_FILTER');
export const setNDPFilter = createAction('SET_NDP_FILTER');

export const setShiftIdFilter = createAction('SET_SHIFT_ID_FILTER');

const initialState = {
	cancel_reason: '',
	dept: '',
	display: 'none',
	from_date: '',
	isndp: '',
	loc: '',
	org: '',
	orgStatus: '',
	page_no: 1,
	role: '',
	search_string: '',
	shift_id: '',
	shift_status: '',
	shiftList: {},
	sort: 'id',
	sortOrder: 'desc',
	state: '',
	supervisor_id: '',
	supervisorList: [],
	timezone: '',
	to_date: ''
};

export default handleActions(
	{
		RESET_SHIFT_LIST: () => initialState,
		SET_DEPT_FILTER: (state, action) => ({ ...state, dept: action.payload }),
		SET_FORM_DATE_FILTER: (state, action) => ({ ...state, from_date: action.payload }),
		SET_LOC_FILTER: (state, action) => ({ ...state, loc: action.payload }),
		SET_NDP_FILTER: (state, action) => ({ ...state, isndp: action.payload }),
		SET_ORG_FILTER: (state, action) => ({ ...state, org: action.payload }),
		SET_ROLE_FILTER: (state, action) => ({ ...state, role: action.payload }),
		SET_SHIFT_DISPLAY_STATE: (state, action) => ({ ...state, display: action.payload }),
		SET_SHIFT_ID_FILTER: (state, action) => ({ ...state, shift_id: action.payload }),
		SET_SHIFT_ORG_STATUS_FILTER: (state, action) => ({ ...state, orgStatus: action.payload }),
		SET_SHIFT_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_SHIFT_STATUS_FILTER: (state, action) => ({ ...state, shift_status: action.payload }),
		SET_SHIFT_TIMEZONE_FILTER: (state, action) => ({ ...state, timezone: action.payload }),
		SET_SHIFTS: (state, action) => ({ ...state, shiftList: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortOrder: action.payload }),
		SET_STATE_FILTER: (state, action) => ({ ...state, state: action.payload }),
		SET_SUPERVISOR_LIST: (state, action) => ({ ...state, supervisorList: action.payload }),
		SET_SUPREVISOR_ID_FILTER: (state, action) => ({ ...state, supervisor_id: action.payload }),
		SET_TO_CANCEL_REASON_FILTER: (state, action) => ({ ...state, cancel_reason: action.payload }),
		SET_TO_DATE_FILTER: (state, action) => ({ ...state, to_date: action.payload })
	},
	initialState
);

export const clearAllValues = () => {
	return function (dispatch) {
		dispatch(setStatusFilter(''));
		dispatch(setOrgFilter(''));
		dispatch(setLocFilter(''));
		dispatch(setDeptFilter(''));
		dispatch(setRoleFilter(''));
		dispatch(setFromDateFilter(''));
		dispatch(setToDateFilter(''));
		dispatch(setCancelReason(''));
		dispatch(setSupervisorIdFilter(''));
		dispatch(setStateFilter(''));
		dispatch(setNDPFilter(''));
		dispatch(setShiftIdFilter(''));
		dispatch(setShiftTimeZoneFilter(''));
	};
};
export const setPageNumber = (pageNo) => {
	return function (dispatch) {
		dispatch(setShiftPageNumber(pageNo));
	};
};

export const getShiftsWithPaging = () => {
	return function (dispatch, getState) {
		dispatch(setShifts([]));
		dispatch(setShiftDisplayState('block'));

		Agent.getShiftsWithPaging(getState().shiftIndex).then((response) => {
			if (response.ok) {
				dispatch(setShifts(response.data));
			} else {
				dispatch(handleError(response));
			}

			dispatch(setShiftDisplayState('none'));
		});
	};
};

export const loadSupervisorList = (all = false) => {
	return function (dispatch, getState) {
		const org = getState().shiftIndex.org != '' ? getState().shiftIndex.org : 'NA';
		const loc = getState().shiftIndex.loc != '' ? getState().shiftIndex.loc : 'NA';
		Agent.supervisors(all ? 'NA' : org, all ? 'NA' : loc).then((response) => {
			if (response.ok) {
				dispatch(setSupervisorList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};
